var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLetsAssemble(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "currentColor",
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.422 4.751 9.778 7.8V5.227a.444.444 0 0 0-.725-.347l-2.8 2.342H4.444V2.804l-2.666-.6v5.018h-.89v7.556a.444.444 0 0 0 .445.444h13.334a.444.444 0 0 0 .444-.444V5.12a.444.444 0 0 0-.689-.369Zm-8.2 9.138H2.667V13h3.555v.889Zm0-1.778H2.667v-.889h3.555v.89Zm0-1.778H2.667v-.889h3.555v.89Zm3.556 3.556h-.89v-1.333h.89v1.333Zm0-2.667h-.89V9.89h.89v1.333Zm1.778 2.667h-.89v-1.333h.89v1.333Zm0-2.667h-.89V9.89h.89v1.333Zm1.777 2.667h-.889v-1.333h.89v1.333Zm0-2.667h-.889V9.89h.89v1.333Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetsAssemble);
export default __webpack_public_path__ + "static/media/LetsAssemble.60d46942dd8a5c689cec8503cbc822fc.svg";
export { ForwardRef as ReactComponent };